import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { AuthGaurdService } from './auth-gaurd.service';
import { environment } from '../../environments/environment';
import { UploadJsonModel } from '../models/commissionsummary/upload-json.model';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CommSummaryModel } from '../models/commissionsummary/commsummary.model';
import { UploadJsonHeadersModel } from '../models/commissionsummary/upload-json-headers.model';
import { WorkFlowMessageModel } from '../models/commissionsummary/workflowmessage.model';
import { Kpimaster } from '../models/commission/kpimaster.model';

@Injectable({
  providedIn: 'root'
})
export class CommissionSummaryService {

  host: string = environment.apiUrl + 'commissionsummary';
  searchCriteriaSet = new Set<string>();
  commSummaryModel = new CommSummaryModel();
  opts = [];

  constructor(private http: HttpClient,
    private logger: LoggerService,
    private authgurdService: AuthGaurdService) { }

  public getKpiCrosstab(): Observable<any> {
    return this.http.get<any>(`${this.host}/getkpicrosstab`);
  }


  public getAdminConfigData(): Observable<CommSummaryModel[]> {
    return this.http.get<CommSummaryModel[]>(`${this.host}/getadminconfigdata`);
  }


  public getKpiActiveList(commplanid: number, effdate: string): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getkpiactivelist/` + commplanid + '/' + effdate);
  }

  public getDropDownsData(): Observable<CommSummaryModel[]> {
    return this.http.get<CommSummaryModel[]>(`${this.host}/getcommsumdropdowns`);
  }

  public getSupDropDownsData(empid: string): Observable<CommSummaryModel[]> {
    return this.http.get<CommSummaryModel[]>(`${this.host}/getcommsumsupdropdowns/` + empid);
  }

  public getUserDropDownsData(empid: string): Observable<CommSummaryModel[]> {
    return this.http.get<CommSummaryModel[]>(`${this.host}/getcommsumuserdropdowns/` + empid);
  }

    public getSalesChannelAdminDropDownsData(empid: string): Observable<CommSummaryModel[]> {
    return this.http.get<CommSummaryModel[]>(`${this.host}/getcommsumscadmindropdowns/` + empid);
  }

  public getHeaderGroups(): Observable<UploadJsonModel[]> {
    return this.http.get<UploadJsonModel[]>(`${this.host}/getheadergroups`);
  }

  public getTrackidCount(trackid: string): Observable<WorkFlowMessageModel[]> {
    return this.http.get<WorkFlowMessageModel[]>(`${this.host}/gettrackidcount/` + encodeURIComponent(trackid));
  }

  public fetchDataByPage(pageName: string, commplanid: number, supervisorStatus: string, selectedSalesChannel: string, eDate: string): Observable<UploadJsonModel[]> {
    return this.http.get<UploadJsonModel[]>(`${this.host}/getdatabypage/` + pageName + '/' + commplanid + '/' + supervisorStatus + '/' + selectedSalesChannel+ '/' + eDate);
  }

  public fetchHeaders(id: number, selectedSalesChannel: string, supervisorStatus: string): Observable<UploadJsonHeadersModel[]> {
    return this.http.get<UploadJsonHeadersModel[]>(`${this.host}/getheaders/` + id + '/' + selectedSalesChannel + '/' + supervisorStatus);
  }

  public getHeaders(id: number, selectedSalesChannel: string, supervisorStatus: string, eDate: string): Observable<UploadJsonHeadersModel[]> {
    return this.http.get<UploadJsonHeadersModel[]>(`${this.host}/fetchheaders/` + id + '/' + selectedSalesChannel + '/' + supervisorStatus+ '/' + eDate);
  }

  public fetchHeaders_dummy(id: number): Observable<UploadJsonHeadersModel[]> {
    return this.http.get<UploadJsonHeadersModel[]>(`${this.host}/getheaders/` + id );
  }

  public fetchDataByPage_dummy(pageName: string, commplanid: number): Observable<UploadJsonModel[]> {
    return this.http.get<UploadJsonModel[]>(`${this.host}/getdatabypage/` + pageName + '/' + commplanid );
  }

  public runSql_dummy(param: string, pageName: string, gridName: string, commplanid: number): Observable<CommSummaryModel[]> {
    return this.http.get<CommSummaryModel[]>(`${this.host}/runsql/` + param + '/' + pageName + '/' + gridName + '/' + commplanid );
  }

  public fetchButtons(id: number): Observable<UploadJsonHeadersModel[]> {
    return this.http.get<UploadJsonHeadersModel[]>(`${this.host}/getbuttons/` + id);
  }

  public getCalcRunningStatus(id: number, calrunid: string): Observable<UploadJsonHeadersModel[]> {
    return this.http.get<UploadJsonHeadersModel[]>(`${this.host}/getcalcrunningstatus/` + id + '/' + calrunid);
  }

  public getSupervisorStatus(id: number): Observable<UploadJsonHeadersModel[]> {
    return this.opts.length ? of(this.opts) : this.http.get<UploadJsonHeadersModel[]>(`${this.host}/getsupervisorstatus/` + id);
  }

  public getPageName(commplanid: number, kpiid: number): Observable<UploadJsonHeadersModel[]> {
    return this.opts.length ? of(this.opts) : this.http.get<UploadJsonHeadersModel[]>(`${this.host}/getpagename/` + commplanid + '/' + kpiid);
  }

  public runSql(param: string, pageName: string, gridName: string, commplanid: number, selectedSalesChannel: string, usertype: string, eDate: string): Observable<CommSummaryModel[]> {
    return this.http.get<CommSummaryModel[]>(`${this.host}/runsql/` + param + '/' + pageName + '/' + gridName + '/' + commplanid + '/' + selectedSalesChannel + '/' + usertype+ '/' + eDate);
  }

  public runSqlSearch(param: string, pageName: string, gridName: string, commplanid: number): Observable<CommSummaryModel[]> {
    return this.http.get<CommSummaryModel[]>(`${this.host}/runreportsearch/` + param + '/' + pageName + '/' + gridName + '/' + commplanid);
  }

  public insertDispute(workFlowMessageModel: WorkFlowMessageModel): Observable<WorkFlowMessageModel> {
    return this.http.post<WorkFlowMessageModel>(`${this.host}/insertdispute`, workFlowMessageModel);
  }

  public insertDisputeStatic(workFlowMessageModel: WorkFlowMessageModel): Observable<WorkFlowMessageModel> {
    return this.http.post<WorkFlowMessageModel>(`${this.host}/insertdisputestatic`, workFlowMessageModel);
  }

  public startCalc(formData: FormData): Observable<CommSummaryModel[]> {
    return this.http.post<CommSummaryModel[]>(`http://10.190.243.60:5000/start_calc`, formData);
  }

}